export const translations = {
    es: {
        nav: ['Inicio', 'Sobre mí', 'Experiencia', 'Proyectos', 'Contacto'],
        about: 'Sobre mí',
        skills: 'Habilidades Técnicas',
        languages: 'Idiomas',
        experience: 'Experiencia Laboral',
        education: 'Formación Académica',
        projects: 'Proyectos Destacados',
        contact: '¿Trabajamos juntos?',
        contactDesc: 'Estoy disponible para nuevos proyectos y oportunidades. ¡Hablemos!',
        contactMe: 'Contáctame',
        addProject: 'Agregar Proyecto',
        addSkill: 'Agregar Skill',
        addExperience: 'Agregar',
        newProject: 'Nuevo Proyecto',
        projectName: 'Nombre del proyecto',
        techUsed: 'Tecnologías usadas',
        projectDesc: 'Descripción del proyecto',
        projectLink: 'Link del proyecto (opcional)',
        newSkill: 'Nueva Habilidad',
        techName: 'Nombre de la tecnología',
        level: 'Nivel',
        newExperience: 'Nueva Experiencia',
        jobTitle: 'Título del puesto',
        company: 'Empresa',
        period: 'Período',
        description: 'Descripción',
        save: 'Guardar',
        cancel: 'Cancelar',
        seeMore: 'Ver más',
        sendEmail: 'Escríbeme!!',
        call: 'Llamar',
        rights: 'Todos los derechos reservados',
        editInfo: 'Editar Información Personal'
    },
    pt: {
        nav: ['Início', 'Sobre mim', 'Experiência', 'Projetos', 'Contato'],
        about: 'Sobre mim',
        skills: 'Habilidades Técnicas',
        languages: 'Idiomas',
        experience: 'Experiência Profissional',
        education: 'Formação Acadêmica',
        projects: 'Projetos Destacados',
        contact: 'Vamos trabalhar juntos?',
        contactDesc: 'Estou disponível para novos projetos e oportunidades. Vamos conversar!',
        contactMe: 'Contate-me',
        addProject: 'Adicionar Projeto',
        addSkill: 'Adicionar Skill',
        addExperience: 'Adicionar',
        newProject: 'Novo Projeto',
        projectName: 'Nome do projeto',
        techUsed: 'Tecnologias utilizadas',
        projectDesc: 'Descrição do projeto',
        projectLink: 'Link do projeto (opcional)',
        newSkill: 'Nova Habilidade',
        techName: 'Nome da tecnologia',
        level: 'Nível',
        newExperience: 'Nova Experiência',
        jobTitle: 'Título do cargo',
        company: 'Empresa',
        period: 'Período',
        description: 'Descrição',
        save: 'Salvar',
        cancel: 'Cancelar',
        seeMore: 'Ver mais',
        sendEmail: 'Enviar Email',
        call: 'Ligar',
        rights: 'Todos os direitos reservados',
        editInfo: 'Editar Informação Pessoal'
    },
    en: {
        nav: ['Home', 'About', 'Experience', 'Projects', 'Contact'],
        about: 'About Me',
        skills: 'Technical Skills',
        languages: 'Languages',
        experience: 'Work Experience',
        education: 'Education',
        projects: 'Featured Projects',
        contact: 'Let\'s Work Together?',
        contactDesc: 'I\'m available for new projects and opportunities. Let\'s talk!',
        contactMe: 'Contact Me',
        addProject: 'Add Project',
        addSkill: 'Add Skill',
        addExperience: 'Add',
        newProject: 'New Project',
        projectName: 'Project name',
        techUsed: 'Technologies used',
        projectDesc: 'Project description',
        projectLink: 'Project link (optional)',
        newSkill: 'New Skill',
        techName: 'Technology name',
        level: 'Level',
        newExperience: 'New Experience',
        jobTitle: 'Job title',
        company: 'Company',
        period: 'Period',
        description: 'Description',
        save: 'Save',
        cancel: 'Cancel',
        seeMore: 'See more',
        sendEmail: 'Send Email',
        call: 'Call',
        rights: 'All rights reserved',
        editInfo: 'Edit Personal Information'
    }
};
